<template>
  <div>
    <outlined-container v-for="(cardChoice, index) in paymentCardChoice"
                        :key="'choice'+index"
                        :active="cardChoice.value === paymentChoice"
                        class="single-choice">
      <div class="single-radio-wrapper">
        <base-radio v-model="paymentChoice"
                    :value="cardChoice.value"
                    name="pickCard"
                    position="right"
                    vertical-align="center"
                    class="radio-single"
                    :label="cardChoice.label">
        </base-radio>
      </div>
    </outlined-container>
    <base-button variant="primary" block class="continue-button" :disabled="!paymentChoice" @click="emitPaymentChoice">{{ $t('common.continue') }}</base-button>
  </div>
</template>

<script>
import cardsConfig from '../mixins/cardsConfig'
import OutlinedContainer from '@/components/common/outlined-container'

export default {
  name: 'payment-modal-payment-choice',
  data () {
    return {
      paymentChoice: ''
    }
  },
  components: { OutlinedContainer },
  mixins: [cardsConfig],
  methods: {
    emitPaymentChoice () {
      this.$emit('selected-choice', this.paymentChoice)
    }
  }
}
</script>

<style scoped lang="scss">
.single-choice {
  margin-bottom: 1.6rem;
}

.single-radio-wrapper {

  .radio-single {
    width: 100%;
    padding: 1.6rem;
  }

  label {
    margin-bottom: 0;
    font-size: 1.4rem;
    font-weight: 600;
    color: $checkbox-label;
  }
}

.continue-button {
  margin-top: 4rem;
}
</style>
